import { useTranslation } from 'react-i18next';
import useAlerts from './useAlerts';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../../hooks/reduxHooks';
import { PRESENTATION_STATE } from '../../Presentaciones/consts';
import { enqueueSnackbar } from 'notistack';
import { useEditCarcinogenicReportEstablishmentMutation } from '../../../services/carcinogenicApi';

const useSendCarcinogenicReport = ({ isReadyToPresent }: { isReadyToPresent: boolean }) => {
    const establishmentData = useAppSelector(
        (state) => state?.carcinogenicReport?.carcinogenicReport?.establecimiento
    );

    const selectedEstablishmentId = useAppSelector(
        (state) => state.establishment.selectedEstablishmentId
    );

    const selectedCarcinogenicReportId = useAppSelector(
        (state) => state?.carcinogenicReport?.selectedCarcinogenicReportId
    );

    const [editCarcinogenicReport, { isLoading: isEditingCarcinogenicReport }] =
        useEditCarcinogenicReportEstablishmentMutation();

    const navigate = useNavigate();
    const { t } = useTranslation('carcinogenicReport');
    const { showSendCarcinogenicReportAlert, showSendCarcinogenicReportFailAlert } = useAlerts({
        translate: t
    });

    const handleSendCarcinogenicReportClickButtonClick = () => {
        if (!isReadyToPresent) {
            showSendCarcinogenicReportFailAlert();
            return;
        }
        showSendCarcinogenicReportAlert({ confirmAction: handleSendCarcinogenicReport });
    };

    const handleSendCarcinogenicReport = async () => {
        try {
            if (!selectedCarcinogenicReportId || !selectedEstablishmentId) return;

            const response: any = await editCarcinogenicReport({
                reportId: selectedCarcinogenicReportId,
                body: {
                    idEstablecimiento: selectedEstablishmentId,
                    establecimiento: establishmentData
                },
                isBorrador: false
            });

            if (response?.error) {
                showSendCarcinogenicReportFailAlert();
            } else {
                enqueueSnackbar(t('enqueues.sendPresentation.success'), {
                    variant: 'success'
                });
                navigate(-1);
            }
        } catch (error) {
            enqueueSnackbar(t('enqueues.sendPresentation.error'), {
                variant: 'error'
            });
        }
    };

    return { handleSendCarcinogenicReportClickButtonClick, isEditingCarcinogenicReport };
};

export default useSendCarcinogenicReport;
